import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { FormProvider } from './context/FormContext';
import { FormRouteGuard } from './components/FormRouteGuard';
import { ErrorBoundary } from './components/ErrorBoundary';
import WelcomePage from './pages/WelcomePage';
import OopsPage from './pages/OopsPage';
import ApplicationForm from './pages/ApplicationForm';
import IncidentForm from './pages/IncidentForm';
import AdditionalInfoForm from './pages/AdditionalInfoForm';
import './App.css';

/** Old bookmarks /welcome/{id} → /{id} */
function LegacyWelcomeRedirect(): JSX.Element {
  const { clientGuid } = useParams();
  const to = clientGuid?.trim() ? `/${clientGuid.trim()}` : '/';
  return <Navigate to={to} replace />;
}

function App(): JSX.Element {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <FormProvider>
          <FormRouteGuard>
            <div className="App">
              <Routes>
                <Route path="/oops" element={<OopsPage />} />
                <Route path="/applications" element={<ApplicationForm />} />
                <Route path="/incidents" element={<IncidentForm />} />
                <Route path="/additional-info" element={<AdditionalInfoForm />} />
                <Route path="/welcome/:clientGuid" element={<LegacyWelcomeRedirect />} />
                <Route path="/welcome" element={<Navigate to="/" replace />} />
                <Route path="/" element={<WelcomePage />} />
                <Route path="/:clientGuid" element={<WelcomePage />} />
                <Route
                  path="*"
                  element={
                    <Navigate
                      to="/oops"
                      replace
                      state={{ reason: 'page_not_found' as const }}
                    />
                  }
                />
              </Routes>
            </div>
          </FormRouteGuard>
        </FormProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
